import React, { useState, useEffect } from 'react';
import { Globe, Check } from 'lucide-react';
import { Button } from '../components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '../components/ui/dropdown-menu';
import { useTranslation } from '../context/TranslationContext';

const LanguageSelector = ({ variant = 'default' }) => {
  const { language, setLanguage, languages } = useTranslation();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    try {
      document.documentElement.lang = language.split('-')[0] || 'en';
    } catch {
      /* ignore */
    }
  }, [language]);

  const current =
    languages.find((l) => l.code === language) ||
    languages.find((l) => l.code === 'en') ||
    { code: 'en', name: 'English', flag: '🇬🇧' };

  return (
    <DropdownMenu open={open} onOpenChange={setOpen}>
      <DropdownMenuTrigger asChild>
        <Button
          variant={variant === 'outline' ? 'outline' : 'ghost'}
          size="sm"
          className="gap-2"
          data-testid="language-selector"
        >
          <Globe className="w-4 h-4" />
          <span className="hidden sm:inline">
            {current.flag} {current.name}
          </span>
          <span className="sm:hidden">{current.flag}</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-48 max-h-80 overflow-y-auto">
        {(languages.length ? languages : [{ code: 'en', name: 'English', flag: '🇬🇧' }]).map(
          (lang) => (
            <DropdownMenuItem
              key={lang.code}
              onClick={() => {
                setLanguage(lang.code);
                setOpen(false);
              }}
              className="flex items-center justify-between cursor-pointer"
            >
              <span className="flex items-center gap-2">
                <span>{lang.flag}</span>
                <span>{lang.name}</span>
              </span>
              {language === lang.code && (
                <Check className="w-4 h-4 text-accent" />
              )}
            </DropdownMenuItem>
          )
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default LanguageSelector;
